import { create } from 'zustand';

export type GlobalRegistrationRequiredModalStoreState = {
  open: boolean;
  loginUrl: string | null;
  description: string | null;

  set: (
    params: Partial<{ open: boolean; loginUrl: string; description: string }>
  ) => void;
};

export const useGlobalRegistrationRequiredModalStore
  = create<GlobalRegistrationRequiredModalStoreState>(set => ({
    open: false,
    loginUrl: null,
    description: null,

    set(delta) {
      set(state => ({
        ...state,
        ...delta,
      }));
    },
  }));
